var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortAscRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.479 6h-3.043c-.843 0-1.521.678-1.521 1.521 0 .843.678 1.522 1.52 1.522h3.044c.843 0 1.521-.679 1.521-1.522S35.322 6 34.479 6zm0 8.114h-7.1c-.843 0-1.521.678-1.521 1.521 0 .843.678 1.522 1.521 1.522h7.1c.843 0 1.521-.679 1.521-1.522s-.678-1.521-1.521-1.521zm0 8.114H23.322c-.843 0-1.521.678-1.521 1.521 0 .843.678 1.522 1.521 1.522h11.157c.843 0 1.521-.679 1.521-1.522s-.678-1.521-1.521-1.521zm0 8.114H19.265c-.843 0-1.521.678-1.521 1.521 0 .843.678 1.522 1.521 1.522h15.214c.843 0 1.521-.679 1.521-1.522s-.678-1.521-1.521-1.521z"
  })));
}
export default SvgSortAscRight;